import type { ReactNode } from 'react';
import { ValuesOf } from '../utils/typeUtils';
import { BROWSER_BAR_SIZES, SKINS } from './BrowserPreviewWidget.constants';

export type BrowserPreviewWidgetSkin = ValuesOf<typeof SKINS>;

export type BrowserBarSizes = ValuesOf<typeof BROWSER_BAR_SIZES>;

export interface BrowserPreviewWidgetProps {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** Background skin. To use `custom` skin, set it to `custom` and use the `backgroundColor` prop
   * @default 'neutral'
   */
  skin?: BrowserPreviewWidgetSkin;
  /** Mobile preview widget background color. Can be set with `design system` colors */
  backgroundColor?: string;
  /** Browser bar height
   * @default 'size12'
   */
  browserBarSize?: BrowserBarSizes;
  /** Sets the height of the component.
   * @default '100%'
   */
  height?: string;
  /** Sets the width of the component
   * @default '100%'
   */
  width?: string;
  /** Node to preview */
  children: ReactNode;
}
